import axios from "axios";
import config from "../config";

const API_BASE = `${config.API_URL}api/settings`;

const themeService = {
    async getTheme() {
        const response = await axios.get(`${API_BASE}/theme`, {
            headers: {
                "Cache-Control": "no-cache",
            },
        });
        return response.data;
    },

    async updateTheme(payload) {
        const response = await axios.put(`${API_BASE}/theme`, payload, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    },
};

export default themeService;

